var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof imageShare !== "undefined") return resolve();
	__webpack_require__.l("/dash-api//public/remote-modules/imageShare/remoteEntry.js", (event) => {
		if(typeof imageShare !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "imageShare");
}).then(() => (imageShare));